import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Trail } from 'react-spring';

import { ComponentHeading } from './elements';
import RecipeItem from './RecipeItem';

const Container = styled.div`
  .is-multiline {
    margin-top: 1rem;
    justify-content: space-between;
  }
`;

const recipes = [
  {
    id: 0,
    image: '/images/recipe_one.jpg',
    title: 'Wilton Peppermint Buttercream',
    description:
      'This festive cake is fast and easy to make—great for breakfast or dessert.Add the perfect holiday touch to your favorite chocolate cake recipe...',
  },
  {
    id: 1,
    image: '/images/recipe_two.jpg',
    title: 'Red Velvet Cupcakes & Cupcakes',
    description:
      'A holiday spin on your favorite red velvet cupcakes: a light cupcake is filled with rich ganache and topped with a spicy buttercre...',
  },
  {
    id: 2,
    image: '/images/recipe_three.jpg',
    title: 'Gluten Free Cranberry Upside Down Cake',
    description:
      'Add the perfect holiday touch to your favorite chocolate cake recipe with this delicious frosting....',
  },
];

const Recipes = () => (
  <Container className="container">
    <div className="section">
      <ComponentHeading
        large
        title="OUR RECIPES"
        subtitle="The active baking community on Bakery constitutes of amazing chefs and expert bakers including professional and home bakers. These baking enthusiasts and baking experts list their favourite baking recipes on our baking blog, sharing their expertise with the entire baking community. Here are their most popular baking recipes ranging from cakes to croissants, pies to puddings!"
      />
      <div className="columns is-multiline is-variable is-6">
        {recipes.map((item) => (
          <RecipeItem item={item} />
        ))}
      </div>
    </div>
  </Container>
);
export default Recipes;
